import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/Loader/LoadingSpinner";
import Modal from "../../components/ImageModal/ImageModal";
import { useNavigate, useLocation } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from "../../media/images/blurredLogo.png";
// import Header from "../../components/Header/Header";
import API_UTIL from "../../services/AuthIntereptor";
import Footer from "../../components/Footer/Footer";
import "../../components/Footer/Footer.css"; // Import the updated CSS
import "./ImagePage.css";
import AppBar from "../../components/AppBar/AppBar";
import MiniHeroComponent from "../../components/MiniHeroComponent/MiniHeroComponent";
import { Icons } from "../../components/ui";

function ImagesPage() {
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState(undefined);
  const [fetchTimeout, setFetchTimeout] = useState(false);
  const [totalImages, setTotalImages] = useState(null);
  const [clickedUrl, setClickedUrl] = useState(null);
  const [clickedImgIndex, setClickedImgIndex] = useState(null);
  const [clickedImgFavourite, setClickedImgFavourite] = useState(null);
  const [clickedImg, setClickedImg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState([]);
  const { eventName, userId } = useParams();
  const isFavouritesFetched = useRef(false);
  const history = useNavigate();
  const location = useLocation();
  const [clientObj, setClientObj] = useState();
  const [userObj,setUserObj] = useState();
  const [bannerImg, setBannerImg]  = useState();

  const handleClick = (item, index) => {
    setClickedImg(item.thumbnail);
    setClickedImgIndex(index);
    setClickedImgFavourite(item.isFavourites);
    const imgName = item.original.split("amazonaws.com/")[1];
    setClickedUrl(imgName);
    window.history.pushState({ id: 1 }, null, "?image=" + `${imgName}`);
  };

  const fetchFavouriteImages = async () => {
    setIsLoading(true);
    try {
      const response = await API_UTIL.post(
        `/images/${eventName}/${userId}`,
        {
          isFavourites: true
        }
      );
      if (response.status === 200) {
        setClientObj(response.data.clientObj);
        await fetchPortfolioImages(response.data.clientObj.user_name,response.data.clientObj.org_name)
        setUserObj(response.data.userObj); //alternative for login
        const formattedImages = response.data.images.map((img) => ({
          original: img.url,
          thumbnail: img.thumbnailUrl,
          isFavourites: true,
        }));
        setImages((prevImages) => [...prevImages, ...formattedImages]);
        if (!totalImages) {
          setTotalImages(response.data.totalImages);
        }
        if (images.length >= totalImages) {
          setIsLoading(false); // Stop fetching more images when all images are fetched
        }
        await fetchImages();
      } else {
        throw new Error("Failed to fetch images");
      }
    } catch (error) {
      if( error?.response?.status === 700){;
        history(`/login/${eventName}`, { state: { from: location } });
      }
      console.error("Error fetching images:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchImages = async () => {
    if (images.length === 0) setIsLoading(true);
    try {
      const response = await API_UTIL.post(
        `/images/${eventName}/${userId}  `,
        {
          isFavourites: false,
          lastEvaluatedKey: lastEvaluatedKey
        }
      );
      if (response.status === 200) {
        const formattedImages = response.data.images.map((img) => ({
          original: img.url,
          thumbnail: img.thumbnailUrl,
          isFavourites: false,
        }));
        setImages((prevImages) => [...prevImages, ...formattedImages]);
        console.log(response.data.lastEvaluatedKey);
        setLastEvaluatedKey(response.data.lastEvaluatedKey);
        if (!totalImages) {
          setTotalImages(response.data.totalImages);
        }
        if (images.length >= totalImages) {
          setIsLoading(false); // Stop fetching more images when all images are fetched
        }
      } else {
        throw new Error("Failed to fetch images");
      }
    } catch (error) {
      console.error("Error fetching images:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPortfolioImages = async (user_name, org_name) => {
    try {
      const response = await API_UTIL.get(`/getPortfolioImages/${org_name}/${user_name}`);
      if (response.status === 200) {
        setBannerImg(response.data.images.Banner[0].url.replace(/ /g, "%20"));

      }
    } catch (error) {
      console.error('Error fetching portfolio images:', error);
    }
  };

  const fetchAllImages = async () => {
    fetchFavouriteImages()

  };

  useEffect(() => {
    if (isFavouritesFetched.current) return;
    fetchAllImages();
    isFavouritesFetched.current = true;
  }, []);

  useEffect(() => {
    if (totalImages === 0) {
      setFetchTimeout(true);
    }
  }, [totalImages]);

  useEffect(() => {
    if (lastEvaluatedKey) {
      console.log("call");
      fetchImages();
    }
    console.log(images.length);
  }, [lastEvaluatedKey]);

  const handleBackButton = () => {
    // Check if the navigation was caused by the back button
    setClickedImg(null);
  };
  useEffect(() => {
    // Add event listener for the popstate event on the window object
    window.addEventListener("popstate", handleBackButton);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);
  useEffect(() => {
    const handleBackGesture = (event) => {
      // Check if the user performed a back gesture
      if (event.deltaX > 50) {
        // Adjust threshold as needed
        setClickedImg(null);
        console.log("back gesture detected");

        // Add your custom logic here, such as navigating back
        history.goBack(); // Navigate back using React Router
      }
    };

    window.addEventListener("touchmove", handleBackGesture);

    return () => {
      window.removeEventListener("touchmove", handleBackGesture);
    };
  }, [history]);

  useEffect(() => {
    const disablePinchZoom = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };
    document.addEventListener("touchmove", disablePinchZoom, {
      passive: false,
    });
    return () => {
      document.removeEventListener("touchmove", disablePinchZoom);
    };
  }, []);

  useEffect(() => {
    function touchHandler(event) {
      if (event.touches.length > 1) {
        //the event is multi-touch
        //you can then prevent the behavior
        event.preventDefault();
      }
    }
    window.addEventListener("touchstart", touchHandler, { passive: false });
    return () => {
      window.removeEventListener("touchstart",touchHandler);
    }
  }, []);

  const handleFavourite = async (index, imageUrl, isFav) => {
    const imageIndex = images.findIndex((image) => image.original === imageUrl);
    const targetIndex = imageIndex >= 0 ? imageIndex : index;

    setImages((currentImages) =>
      currentImages.map((image, currentIndex) =>
        currentIndex === targetIndex ? { ...image, isFavourites: isFav } : image
      )
    );
    setClickedImgIndex(targetIndex);

    await API_UTIL.post("/setFavourites", {
      imageUrl,
      userId,
      isFav,
    });
  };

  const displayFavIcon = (index) => {
    console.log(index);
    document
      .querySelector(`svg[data-key="${index}"]`)
      .classList.remove("hidden");
  };

  const toggleFavourite = (index) => {
    const isFav = !images[index].isFavourites;
    handleFavourite(index, images[index].original, isFav);
  };

  console.log(clientObj);

  return (
    <div className="bg-white text-slate-900 min-h-screen flex flex-col">
      {isLoading ? (
        <div className="grid place-items-center min-h-screen">
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <AppBar/>

          {/* Hero band */}
          <div className="relative h-56 sm:h-72 overflow-hidden border-b border-gray-200">
            <MiniHeroComponent
              orgName={clientObj?.org_name}
              socialMediaLinks={clientObj?.social_media}
              backdropImage={bannerImg}
            />
          </div>

          <div className="fade-in max-w-[1400px] mx-auto w-full px-4 sm:px-6 py-8 flex-1">
            {images.length > 0 ? (
              <div className="masonry columns-2 sm:columns-3 lg:columns-3 xl:columns-4">
                {images.map((item, index) => (
                  <div
                    key={index}
                    className="relative rounded-xl overflow-hidden bg-gray-100 border border-gray-200 group mb-4 cursor-pointer"
                  >
                    <LazyLoadImage
                      src={item.thumbnail}
                      placeholderSrc={PlaceholderImage}
                      effect="blur"
                      className="w-full h-auto object-cover transition-transform duration-300 group-hover:scale-105"
                      onLoad={() => item.isFavourites && displayFavIcon(index)}
                      onClick={() => handleClick(item, index)}
                    />
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent the click from triggering the image click
                        toggleFavourite(index);
                      }}
                      className="absolute bottom-2 right-2 w-8 h-8 grid place-items-center bg-white/95 backdrop-blur rounded-full border border-gray-200 shadow-soft opacity-90 group-hover:opacity-100 transition z-10"
                      aria-label={item.isFavourites ? "Unfavourite" : "Favourite"}
                    >
                      <Icons.Heart
                        data-key={index}
                        filled={item.isFavourites}
                        className="w-4 h-4"
                      />
                    </button>
                  </div>
                ))}
                <div>
                  {clickedImg && (
                    <div className="fixed top-0 right-0 bottom-0 w-full md:w-1/2 bg-black z-[1000] flex items-center justify-center">
                      <Modal
                        clickedImg={clickedImg}
                        clickedImgIndex={clickedImgIndex}
                        clickedImgFavourite={clickedImgFavourite}
                        setClickedImg={setClickedImg}
                        clickedUrl={clickedUrl}
                        handleBackButton={handleBackButton}
                        handleFavourite={handleFavourite}
                        images={images} // Pass the images array to Modal
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : fetchTimeout ? (
              <p className="text-center text-slate-500 py-24">No images to display</p> // Message shown if fetch timeout is reached
            ) : (
              <p className="text-center text-slate-500 py-24">Failed to load images</p> // Message shown if images fetch fails for other reasons
            )}
          </div>
          <Footer />
        </>
      )}
    </div>
  );
}

export default ImagesPage;
